import { message } from 'antd';
import { ChatNotify, ReadyForPickup } from 'services/invoice';
import http from '../httpService';
import { CreateNotification } from './dto/notification';

class NotificationService {
  public async create(notification: CreateNotification) {
    await http.post(
      'api/services/app/Notification/NotifyDropOffTimeServiceOrderUser',
      notification
    );
  }
  public async readyForPickup(request: ReadyForPickup) {
    try {
      await http.post('api/services/app/Notification/ReadyForPickup', request);

      message.success({
        content: 'Successfully sent!',
      });
    } catch (error: any) {
      message.error({ content: error.response.data.error.message });
    }
  }
  public async sendChatMessageNotification(notificationRequest: ChatNotify) {
    try {
      await http.post('api/services/app/Notification/SendChatNotification', notificationRequest);
    } catch (error) {
      /* empty */
    }
  }
  public async sendCustomerSmsInvitation(id: string): Promise<any> {
    await http
      .post('api/services/app/Notification/SendCustomerSmsInvitation', { id })
      .then(() => {
        message.success('Successfully sent!');
      })
      .catch((error: any) => {
        message.error({ content: error.response.data.error.message });
      });
  }

  public async SendCustomerEstimateInvitation({
    id,
    orderId,
  }: {
    id: string;
    orderId: string;
  }): Promise<any> {
    await http
      .post('api/services/app/Notification/SendCustomerEstimateInvitation', { id, orderId })
      .then(() => {
        message.success('Successfully sent!');
      })
      .catch((error: any) => {
        message.error({ content: error.response.data.error.message });
      });
  }

  //MAYBE TEMP
  public async sendCustomerEmailReceipt(invoiceId: string, email: string): Promise<any> {
    // console.log("Sending email to ", email);
    // console.log("For invoice ", invoiceId);
    await http
      //SendCustomerEmailReceipt?invoiceId=9263f012-a7e6-4723-fc98-08ddde3e9d0f&email=sdfsdf
      .post(
        `api/services/app/Notification/SendCustomerEmailReceipt?invoiceId=${invoiceId}&email=${email}`
      )
      .then(() => {
        message.success('Successfully sent!');
      })
      .catch((error: any) => {
        message.error({ content: error.response.data.error.message });
      });
  }
}
export default new NotificationService();
